module.exports = __webpack_public_path__ + "static/media/watermark_mfi.196a6e34.png";